import { isEmptyConvertProjection } from '#/modules/imsMgmt/settings/mtr/helper/unitAggregateSerialize';

/**
 * 從 Material detail 的 unit aggregate 合成 unit_options 形狀（僅 ACTIVE base／convert）。
 * `convert` 為單一 object；空投影略過。
 * @param {{ base?: object, convert?: object|object[]|null }|null|undefined} unit
 * @returns {object[]}
 */
function optionsFromUnitAggregate(unit) {
  if (!unit || typeof unit !== 'object') {
    return [];
  }

  const rows = [];
  const base = unit.base;
  if (base && (base.id || base.code || base.name)) {
    rows.push({
      id: base.id ?? '',
      code: base.code ?? '',
      name: base.name ?? '',
      baseUnit: true,
    });
  }

  let convertRow = null;
  if (Array.isArray(unit.convert)) {
    convertRow = unit.convert.find((row) => !isEmptyConvertProjection(row)) ?? null;
  } else if (!isEmptyConvertProjection(unit.convert)) {
    convertRow = unit.convert;
  }

  if (convertRow) {
    const item = {
      id: convertRow.id ?? '',
      code: convertRow.code ?? '',
      name: convertRow.name ?? '',
      baseUnit: false,
    };
    if (convertRow.convertRate != null && convertRow.convertRate !== '') {
      item.convertRate = convertRow.convertRate;
    }
    rows.push(item);
  }

  return rows;
}

/**
 * 相容 detail.unitOptions、line.mtr／material.unitOptions、直傳陣列；
 * Material detail 若僅有 unit aggregate 則合成選單列。
 * @param {unknown} from
 * @returns {object[]}
 */
export function extractUnitOptions(from) {
  if (from == null) {
    return [];
  }

  if (Array.isArray(from)) {
    return from;
  }

  if (typeof from !== 'object') {
    return [];
  }

  if (Array.isArray(from.unitOptions)) {
    return from.unitOptions;
  }

  if (Array.isArray(from.mtr?.unitOptions)) {
    return from.mtr.unitOptions;
  }

  if (Array.isArray(from.material?.unitOptions)) {
    return from.material.unitOptions;
  }

  if (from.unit && typeof from.unit === 'object') {
    return optionsFromUnitAggregate(from.unit);
  }

  if (from.mtr?.unit && typeof from.mtr.unit === 'object') {
    return optionsFromUnitAggregate(from.mtr.unit);
  }

  if (from.material?.unit && typeof from.material.unit === 'object') {
    return optionsFromUnitAggregate(from.material.unit);
  }

  return [];
}
